"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3543],{

/***/ 3543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CityCountryDT; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7311);
/* eslint-disable react/no-danger */ 

function CityCountryDT(props) {
    var ref = (props === null || props === void 0 ? void 0 : props.data) || {}, mainDiv = ref.main_div, tmp = ref.initial_js, initialJS = tmp === void 0 ? "" : tmp, top_overlay = ref.top_overlay;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            initialJS && initialJS !== "" ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(initialJS) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: mainDiv
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: top_overlay
                }
            })
        ]
    });
}


/***/ })

}]);